var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from "../../componentWrappers";
import { t } from "../../I18N";
import { actions as formActions, Field, LocalForm } from 'react-redux-form';
import { searchSnippets } from "../../Library/actions/libraryActions";
import { selectSnippet } from "../../Viewer/actions/uiActions";
import { Icon } from "../../UI";
import ModalTips from "../../App/ModalTips";
import { toUrlParams } from "../../../shared/JSONRequest";
import { SearchTipsContent } from "../../App/SearchTipsContent";
import { searchParamsFromSearchParams } from "../../utils/routeHelpers";
import SnippetList from "./SnippetList";

class SearchText extends Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
  }

  componentDidMount() {
    if (this.props.storeKey === 'documentViewer') {
      this.searchSnippets(this.props.searchTerm, this.props.doc.get('sharedId'));
    }
  }

  componentDidUpdate(prevProps) {
    if (
    prevProps.searchTerm !== this.props.searchTerm ||
    prevProps.doc.get('sharedId') !== this.props.doc.get('sharedId'))
    {
      this.searchSnippets(this.props.searchTerm, this.props.doc.get('sharedId'));
    }
  }

  attachDispatch(dispatch) {
    this.formDispatch = dispatch;
  }

  resetSearch() {}

  searchSnippets(searchTerm, sharedId) {
    if (sharedId) {
      this.props.searchSnippets(searchTerm, sharedId, this.props.storeKey);
      if (this.formDispatch) {
        this.formDispatch(formActions.change('searchText.searchTerm', searchTerm));
      }
    }
  }

  submit(value) {
    const path = this.props.location.pathname;

    const query = searchParamsFromSearchParams(this.props.searchParams);
    query.searchTerm = value.searchTerm;

    this.props.navigate(path + toUrlParams(query));

    return this.props.searchSnippets(
      value.searchTerm,
      this.props.doc.get('sharedId'),
      this.props.storeKey
    );
  }

  render() {
    const { doc, snippets } = this.props;
    const documentViewUrl = doc.get('file') ?
    `/document/${doc.get('sharedId')}` :
    `/entity/${doc.get('sharedId')}`;
    return /*#__PURE__*/(
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx(LocalForm, {
        model: "searchText",
        onSubmit: this.submit,
        getDispatch: (dispatch) => this.attachDispatch(dispatch),
        autoComplete: "off" }, void 0,

      this.props.storeKey === 'documentViewer' && /*#__PURE__*/
      _jsx("div", { className: "search-box" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "input-group" }, void 0, /*#__PURE__*/
      _jsx(Field, { model: ".searchTerm" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "search" }), /*#__PURE__*/
      _jsx("input", {
        type: "text",
        placeholder: t('System', 'Search related entities or documents', null, false),
        className: "form-control",
        autoComplete: "off",
        "aria-label": t('System', 'Search text description', null, false) }
      ), /*#__PURE__*/
      _jsx(Icon, { icon: "times", onClick: this.resetSearch })
      )
      ), /*#__PURE__*/
      _jsx(ModalTips, {
        label: t('System', 'Search Tips', null, false),
        title: t('System', 'Narrow down your searches', null, false) }, void 0, /*#__PURE__*/

      _jsx(SearchTipsContent, {})
      )
      )

      ),

      !snippets.get('count') && /*#__PURE__*/
      _jsx("div", { className: "blank-state" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "search" }), /*#__PURE__*/
      _jsx("h4", {}, void 0, t('System', !this.props.searchTerm ? 'Search text' : 'No text match')), /*#__PURE__*/
      _jsx("p", {}, void 0,
      t(
        'System',
        !this.props.searchTerm ? 'Search text description' : 'No text match description'
      )
      )
      ),

      doc.size ? /*#__PURE__*/
      _jsx(SnippetList, {
        doc: this.props.doc,
        snippets: snippets,
        selectSnippet: this.props.selectSnippet,
        searchTerm: this.props.searchTerm,
        documentViewUrl: documentViewUrl }
      ) :

      ''

      ));

  }
}




















SearchText.defaultProps = {
  searchTerm: '',
  snippets: {
    count: 0,
    metadata: [],
    fullText: []
  }
};

function mapStateToProps(state, props) {
  return {
    snippets: state[props.storeKey].sidepanel.snippets
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ searchSnippets, selectSnippet }, dispatch);
}

export { SearchText };
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SearchText));